import React from 'react';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';

class Results extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      show: !this.state.show
    });

    this.refreshPage();
  }

  refreshPage() {
    window.location.reload(false);
  }

  // componentDidMount() {
  //   window.location="https://secure.actblue.com/donate/julie-ema10"
  // }

  render() {
    return (
      <div 
        className="p-3 my-2 rounded" 
        style={{ background: 'inherit' 
        }}>
        {/*<Button color="primary" onClick={this.toggle}>{this.props.buttonLabel}</Button>*/}
        <br />
        <br />
        <Toast isOpen={this.state.show} >
          <ToastHeader toggle={this.toggle}><span role="img" aria-label="hi-five">🙌</span>Success!</ToastHeader>
          <ToastBody>
            <br />
            <div>
            <p>Thanks for signing up!</p>
            <p>We'll be in touch with updates. Don't forget to remind everyone: </p>
            <p><strong>Early Voting begins October 13, 2020, and Election Day is Tuesday, November 3, 2020.</strong></p>
            <p>We've got all the info you need at <a href="https://julieoliver.org/vote">julieoliver.org/vote</a></p>
            </div>
          </ToastBody>
        </Toast>
      </div>
    );
  }
}

export default Results;